import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CoachLink from 'components/coachSalesPages/CoachLink';

function mapStateToProps(state, ownProps) {
  const { paymentReducer } = state;
  return {
    logo: paymentReducer.get('logo'),
    siteCheckout: paymentReducer.get('siteCheckout'),
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch),
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CoachLink);


// WEBPACK FOOTER //
// ./src/containers/CoachLinkContainer.js